import LoadingIcon from '@components/icons/Loading.svg';
import { TProps } from './types/TProps';

export const ActionButtonContent = ({ action }: TProps) => {
  const Icon = action.icon;

  return (
    <>
      {action.loading ? <LoadingIcon className="h-3 w-3 animate-spin" /> : Icon ? <Icon height="12px" /> : null}
      {action.label}
    </>
  );
};
